import type { VehicleIdentityFieldKey } from 'korint-sdk/react';

// Hidden required checkbox: set false while a comparison choice is pending → resolver fails → blocks Suivant.
export const VEHICLE_SELECTION_RESOLVED_FIELD = 'vehicleSelectionResolved';

export const DEFAULT_VEHICLE_IDENTITY_FIELDS: Array<VehicleIdentityFieldKey> = [
  'registrationNumber',
  'brand',
  'model',
  'version',
  'firstCirculationDate',
];
